import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { getFullImageUrl, getYoutubePreviewImage, YOUTUBE_PREVIEW_SIZE } from 'client/utils/image-helpers';
import { EmbeddedYoutube } from 'site-modules/shared/components/video/embedded-youtube/embedded-youtube';
import { TruncatedTextLite } from 'site-modules/shared/components/truncated-text-lite/truncated-text-lite';
import { VideoPreview } from 'site-modules/shared/components/video-preview/video-preview';

const DESCRIPTION_ID = 'highlight-description';
const CREATIVE_ID = 'highlight_video';
const DEFAULT_VIDEO_TITLE = 'Highlight video';
const HIGHLIGHT_VIDEO_PREVIEW_SIZE = {
  MOBILE: 300,
  DESKTOP: 500,
};
const HIGHLIGHT_TEXT_MOBILE_LENGTH = 160;

export function HighlightVideo({ entry, openVideoModal, isMobile = false, videoAspectRatio = '16:9' }) {
  const videoId = entry.metadata('videoId').value();
  const displayVideoTitle = entry.metadata('videoTitle').value();
  const videoTitle = displayVideoTitle || DEFAULT_VIDEO_TITLE;
  const thumbnailURL = entry.metadata('thumbnailURL').value();
  const videoDescription = entry.metadata('videoDescription').value();
  const thumbnailSrc = thumbnailURL
    ? getFullImageUrl(
        thumbnailURL,
        isMobile ? HIGHLIGHT_VIDEO_PREVIEW_SIZE.MOBILE : HIGHLIGHT_VIDEO_PREVIEW_SIZE.DESKTOP
      )
    : getYoutubePreviewImage(videoId, YOUTUBE_PREVIEW_SIZE.MAX_RES);
  return (
    <div className="highlight-video clearfix mb-1_5" aria-describedby={DESCRIPTION_ID}>
      <div className={classnames('pos-r', { 'mb-1': !isMobile, 'float-start mb-0_5 me-1 w-50': isMobile })}>
        {isMobile ? (
          <EmbeddedYoutube
            videoId={videoId}
            videoTitle={videoTitle}
            creativeId={CREATIVE_ID}
            thumbnailSrc={thumbnailSrc}
            videoAspectRatio={videoAspectRatio}
          />
        ) : (
          <VideoPreview
            videoThumbnailUrl={thumbnailSrc}
            videoId={videoId}
            openVideoModal={openVideoModal}
            videoTitle={videoTitle}
            creativeId={CREATIVE_ID}
            isStaticPos
            videoAspectRatio={videoAspectRatio}
          />
        )}
      </div>
      <div id={DESCRIPTION_ID} className="text-gray-darker">
        {!!displayVideoTitle && <h2 className="heading-5 mb-0_5">{displayVideoTitle}</h2>}
        {isMobile ? (
          <TruncatedTextLite
            text={videoDescription}
            maxTextLength={HIGHLIGHT_TEXT_MOBILE_LENGTH}
            btnClassName="size-16 text-gray-darker"
            indicatorOpenClass="icon-arrow-down4 text-primary-darker small ps-0_5"
            indicatorCloseClass="icon-arrow-up4 text-primary-darker small ps-0_5"
          />
        ) : (
          videoDescription
        )}
      </div>
    </div>
  );
}

HighlightVideo.propTypes = {
  entry: CmsEntities.Content.isRequired,
  openVideoModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  videoAspectRatio: PropTypes.string,
};
